import "./Button.css";
import React, { useState } from "react";
import Unsplash, { toJson } from "unsplash-js";
// const API_KEY = process.env.REACT_APP_API_KEY;
const unsplash = new Unsplash({
  accessKey: "ngH_LHSp5AkF2yhuPOKvhbYrBL3RLXjZ_gsvNO7dQiA",
});
export default function SearchPhotos() {
  const [query, setQuery] = useState("");
  const [pics, setPics] = useState([]);

  const searchPhotos = async (e) => {
    e.preventDefault();
    unsplash.search
      .photos(query, 1, 20)
      .then(toJson)
      .then((json) => {
        setPics(json.results);
      });
  };

  return (
    <>
      <form className="form" onSubmit={searchPhotos}>
        <label className="label" htmlFor="query">
          {" "}
        </label>
        <input
          type="text"
          name="query"
          className="input glow-on-hover-input"
          placeholder={`Try Any "Image"`}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button type="submit" className="glow-on-hover">
          Search
        </button>
      </form>
      <div className="card-list">
        {pics.map((pic) => (
          <div className="card" key={pic.id}>
            <img
              className="card--image"
              alt={pic.alt_description}
              src={pic.urls.full}
              width="50%"
              height="50%"
            ></img>
          </div>
        ))}
      </div>
    </>
  );
}
